// ============================================================
// APOTHEEK BESTELINTERFACE
// ============================================================

const CONFIG = window.APOTHEEK_CONFIG;
let alleProducten = [];
let gefilterdProducten = [];
let bestelling = {};
let zoekTimer = null;

// ============================================================
// STOREFRONT API — alle producten laden via paginering
// ============================================================
async function fetchAlleProducten(handle) {
  let cursor = null;
  let producten = [];
  let hasNextPage = true;

  while (hasNextPage) {
    const url = new URL('https://apotheek-draft-order.frederik-lesaffre.workers.dev/products');
    url.searchParams.set('collection', handle);
    if (cursor) url.searchParams.set('cursor', cursor);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    const data = await response.json();
    const collectie = data.data?.collection;
    if (!collectie) break;

    producten = producten.concat(collectie.products.nodes);
    hasNextPage = collectie.products.pageInfo.hasNextPage;
    cursor = collectie.products.pageInfo.endCursor;
  }

  return producten;
}

// ============================================================
// FILTERS OPBOUWEN
// ============================================================
function bouwFilters() {
  const merken = [...new Set(alleProducten.map(p => p.vendor).filter(Boolean))].sort();
  const categorieen = [...new Set(alleProducten.map(p => p.productType).filter(Boolean))].sort();

  // Merkicoontjes bovenaan
  const merkIconContainer = document.getElementById('merk-iconen');
  if (merkIconContainer) {
    merkIconContainer.innerHTML = merken.map(merk => `
      <button class="merk-icoon-btn" data-merk="${merk}">${merk}</button>
    `).join('');
    merkIconContainer.querySelectorAll('.merk-icoon-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.classList.toggle('active');
        pasFiltersTo();
      });
    });
  }

  // Merkfilter links met count
  const merkFilterContainer = document.getElementById('filter-merken');
  if (merkFilterContainer) {
    merkFilterContainer.innerHTML = merken.map(merk => {
      const count = alleProducten.filter(p => p.vendor === merk).length;
      return `
        <label class="filter-label">
          <input type="checkbox" class="filter-merk-cb" value="${merk}">
          ${merk} <span class="filter-count">(${count})</span>
        </label>
      `;
    }).join('');
    merkFilterContainer.querySelectorAll('.filter-merk-cb').forEach(cb => {
      cb.addEventListener('change', pasFiltersTo);
    });
  }

  // Categoriefilter links met count
  const catFilterContainer = document.getElementById('filter-categorieen');
  if (catFilterContainer && categorieen.length > 0) {
    catFilterContainer.innerHTML = categorieen.map(cat => {
      const count = alleProducten.filter(p => p.productType === cat).length;
      return `
        <label class="filter-label">
          <input type="checkbox" class="filter-cat-cb" value="${cat}">
          ${cat} <span class="filter-count">(${count})</span>
        </label>
      `;
    }).join('');
    catFilterContainer.querySelectorAll('.filter-cat-cb').forEach(cb => {
      cb.addEventListener('change', pasFiltersTo);
    });
  }

  // Inklapbare secties
  document.querySelectorAll('.filter-sectie-header').forEach(header => {
    header.addEventListener('click', () => {
      const target = document.getElementById(header.dataset.target);
      if (target) {
        target.classList.toggle('verborgen');
        header.classList.toggle('gesloten');
      }
    });
  });

  // Reset filters
  document.getElementById('reset-filters')?.addEventListener('click', () => {
    document.querySelectorAll('.filter-merk-cb, .filter-cat-cb').forEach(cb => cb.checked = false);
    document.querySelectorAll('.merk-icoon-btn').forEach(btn => btn.classList.remove('active'));
    document.getElementById('zoek-input').value = '';
    pasFiltersTo();
  });
}

// ============================================================
// FILTERS TOEPASSEN
// ============================================================
function pasFiltersTo() {
  const geselecteerdeMerkenIcon = [...document.querySelectorAll('.merk-icoon-btn.active')]
    .map(b => b.dataset.merk);
  const geselecteerdeMerkenCb = [...document.querySelectorAll('.filter-merk-cb:checked')]
    .map(cb => cb.value);
  const geselecteerdeMerken = [...new Set([...geselecteerdeMerkenIcon, ...geselecteerdeMerkenCb])];
  const geselecteerdeCategorieen = [...document.querySelectorAll('.filter-cat-cb:checked')]
    .map(cb => cb.value);
  const zoekterm = document.getElementById('zoek-input')?.value.toLowerCase() || '';

  gefilterdProducten = alleProducten.filter(p => {
    const merkMatch = geselecteerdeMerken.length === 0 || geselecteerdeMerken.includes(p.vendor);
    const catMatch = geselecteerdeCategorieen.length === 0 || geselecteerdeCategorieen.includes(p.productType);
    const titelMatch = p.title.toLowerCase().includes(zoekterm);
    const skuMatch = p.variants.nodes.some(v => (v.sku || '').toLowerCase().includes(zoekterm));
    const zoekMatch = zoekterm === '' || titelMatch || skuMatch;
    const beschikbaar = p.variants.nodes.some(v => v.availableForSale);
    return merkMatch && catMatch && zoekMatch && beschikbaar;
  });

  renderProducten(gefilterdProducten);
  document.getElementById('resultaat-aantal').textContent =
    `${gefilterdProducten.length} producten`;
}

// ============================================================
// RENDER PRODUCTGRID
// ============================================================
function renderProducten(producten) {
  const grid = document.getElementById('product-grid');
  grid.innerHTML = '';

  if (!producten || producten.length === 0) {
    grid.innerHTML = '<p class="apotheek-leeg">Geen producten gevonden.</p>';
    return;
  }

  producten.forEach(product => {
    const afbeelding = product.images.nodes[0];
    const beschikbareVarianten = product.variants.nodes.filter(v => v.availableForSale);
    if (beschikbareVarianten.length === 0) return;

    const kaart = document.createElement('div');
    kaart.className = 'apotheek-product-kaart';

    kaart.innerHTML = `
      <div class="apotheek-product-foto">
        ${afbeelding
          ? `<img src="${afbeelding.url}" alt="${afbeelding.altText || product.title}" loading="lazy" />`
          : '<div class="apotheek-geen-foto">Geen foto</div>'
        }
      </div>
      <div class="apotheek-product-info">
        <p class="apotheek-product-merk">${product.vendor || ''}</p>
        <h3 class="apotheek-product-naam">${product.title}</h3>
        <div class="apotheek-varianten">
          ${beschikbareVarianten.map(variant => {
            // KOSTPRIJS — wordt ingevuld na metafield check
            const kostprijs = variant.compareAtPrice
              ? `<span class="apotheek-kostprijs">Kostprijs: €${parseFloat(variant.compareAtPrice.amount).toFixed(2)}</span>`
              : '';
            return `
              <div class="apotheek-variant-rij">
                <div class="apotheek-variant-details">
                  ${variant.title !== 'Default Title' ? `<span class="apotheek-variant-naam">${variant.title}</span>` : ''}
                  <span class="apotheek-variant-sku">SKU: ${variant.sku || '-'}</span>
                  <span class="apotheek-variant-stock">${variant.quantityAvailable} beschikbaar</span>
                </div>
                <div class="apotheek-variant-rechts">
                  <div>
                    <div class="apotheek-variant-prijs">€${parseFloat(variant.price.amount).toFixed(2)}</div>
                    ${kostprijs}
                  </div>
                  <div class="apotheek-variant-aantal">
                    <button class="qty-btn minus" data-variant="${variant.id}">−</button>
                    <input
                      type="number"
                      class="qty-input"
                      data-variant="${variant.id}"
                      data-titel="${product.title}${variant.title !== 'Default Title' ? ' - ' + variant.title : ''}"
                      data-sku="${variant.sku || ''}"
                      data-prijs="${variant.price.amount}"
                      min="0"
                      value="0"
                    />
                    <button class="qty-btn plus" data-variant="${variant.id}">+</button>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;

    grid.appendChild(kaart);
  });

  herstelAantallen();
  bindQtyEvents();
}

// ============================================================
// QUANTITY EVENTS
// ============================================================
function bindQtyEvents() {
  document.querySelectorAll('.qty-input').forEach(input => {
    input.addEventListener('change', updateBestelling);
  });
  document.querySelectorAll('.qty-btn.plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`.qty-input[data-variant="${btn.dataset.variant}"]`);
      input.value = parseInt(input.value || 0) + 1;
      updateBestelling({ target: input });
    });
  });
  document.querySelectorAll('.qty-btn.minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`.qty-input[data-variant="${btn.dataset.variant}"]`);
      input.value = Math.max(0, parseInt(input.value || 0) - 1);
      updateBestelling({ target: input });
    });
  });
}

function updateBestelling(e) {
  const input = e.target;
  const variantId = input.dataset.variant;
  const aantal = parseInt(input.value) || 0;
  if (aantal > 0) {
    bestelling[variantId] = {
      titel: input.dataset.titel,
      sku: input.dataset.sku,
      prijs: parseFloat(input.dataset.prijs),
      aantal
    };
  } else {
    delete bestelling[variantId];
  }
  updateBestellingUI();
}

function herstelAantallen() {
  Object.entries(bestelling).forEach(([variantId, item]) => {
    const input = document.querySelector(`.qty-input[data-variant="${variantId}"]`);
    if (input) input.value = item.aantal;
  });
}

function updateBestellingUI() {
  const totalItems = Object.values(bestelling).reduce((s, i) => s + i.aantal, 0);
  const totalPrijs = Object.values(bestelling).reduce((s, i) => s + i.prijs * i.aantal, 0);
  document.getElementById('aantal-items').textContent = totalItems;
  document.getElementById('submit-bestelling').disabled = totalItems === 0;
  document.getElementById('bestelling-samenvatting').innerHTML = totalItems > 0
    ? `<strong>${totalItems} producten</strong> — €${totalPrijs.toFixed(2)}`
    : '';
}

// ============================================================
// ZOEKEN
// ============================================================
document.getElementById('zoek-input').addEventListener('input', () => {
  clearTimeout(zoekTimer);
  zoekTimer = setTimeout(pasFiltersTo, 300);
});

// ============================================================
// DRAFT ORDER SUBMIT
// ============================================================
document.getElementById('submit-bestelling').addEventListener('click', async () => {
  const btn = document.getElementById('submit-bestelling');
  btn.disabled = true;
  btn.textContent = 'Bestelling wordt verwerkt...';

  const lijnitems = Object.entries(bestelling).map(([variantId, item]) => ({
    variant_id: variantId.replace('gid://shopify/ProductVariant/', ''),
    quantity: item.aantal,
    titel: item.titel,
    sku: item.sku,
    price: item.prijs.toFixed(2)
  }));

  try {
    const response = await fetch(CONFIG.endpointDraftOrder, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: CONFIG.customerID,
        customer_email: CONFIG.customerEmail,
        customer_naam: CONFIG.customerNaam,
        line_items: lijnitems
      })
    });

    if (response.ok) {
      document.querySelector('.apotheek-bestelinterface').innerHTML = `
        <div class="apotheek-bevestiging">
          <h2>✅ Bestelling ontvangen!</h2>
          <p>Bedankt. U ontvangt een bevestiging via e-mail.</p>
          <a href="/pages/apotheek-bestelling" class="btn">Nieuwe bestelling plaatsen</a>
        </div>
      `;
    } else {
      alert('Er liep iets mis. Probeer opnieuw.');
      btn.disabled = false;
      btn.textContent = `Bestelling plaatsen (${Object.values(bestelling).reduce((s,i)=>s+i.aantal,0)} producten)`;
    }
  } catch (err) {
    console.error(err);
    alert('Verbindingsfout. Probeer opnieuw.');
    btn.disabled = false;
  }
});

// ============================================================
// INIT
// ============================================================
async function init() {
  document.getElementById('product-grid').innerHTML =
    '<div style="padding:2rem;color:#888;">Producten laden...</div>';
  alleProducten = await fetchAlleProducten(CONFIG.collectionHandle || 'bestelling-apotheek');
  bouwFilters();
  pasFiltersTo();
}

init();
